import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { startJourney, journeyPage } from "../lib/journey";

export default function ScrollToTop() {
    const { pathname, search } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);
    // 3 Nov 2026: journey tracking (admin › Journey / CRM) - one page view per route
    useEffect(() => { startJourney(); }, []);
    useEffect(() => { journeyPage(); }, [pathname, search]);
    return null;
}
